import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@design-system/image';
import { ContentListLinkWrapper } from './ContentListLinkWrapper';
export const ContentListCover = ({ ariaLabel, imageSrc, isHovered, path, tabIndex, withLink, }) => (_jsx(ContentListLinkWrapper, { ariaLabel: ariaLabel, path: path, tabIndex: tabIndex, withLink: withLink, children: _jsx(Image, { alt: "", height: "100%", src: imageSrc, style: {
            objectFit: 'cover',
            transform: isHovered ? 'scale(1.10)' : 'scale(1)',
            transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1)',
        }, width: "100%" }) }));
//# sourceMappingURL=ContentListCover.js.map